import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  tooltip: {
    padding: theme.spacing(5, 16, 6),
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(6),
    boxShadow: '0px 8px 30px #00000012',
    textAlign: 'center',
  },
  ordersCountLabel: {
    fontWeight: 600,
    lineHeight: '25px',
    paddingBottom: theme.spacing(2),
  },
  dateLabel: {
    lineHeight: '18px',
    color: theme.palette.grey[400],
  },
  tick: {
    fontSize: 14,
    lineHeight: '21px',
    color: theme.palette.grey[400],
    marginTop: 20,
  },
}));
